import React, { Component } from 'react';
import CargomaticCard from 'components/v2/card';
import CargomaticModal from 'components/v2/modal';
import CustomerSearch from 'components/site/customer-search-alt';
import { getCarrierPreferences, updateCarrierPreferences, } from 'utils/CarrierPreferencesAPI';
import classnames from 'classnames';
import { sortableContainer, sortableElement, arrayMove, } from 'react-sortable-hoc';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import InfoIcon from 'components/v2/icons/InfoIcon';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import CargomaticInput from '../../../v2/input';
import EditButton from '../../../v2/buttons/EditButton';
const SortableItem = sortableElement(({ children }) => (React.createElement("tr", { className: "cursor-pointer" }, children)));
const SortableContainer = sortableContainer(({ children }) => {
    return React.createElement("tbody", null, children);
});
const TOOLTIPS = {
    preferredCarrier: 'PREFERRED_CARRIER_FOR_SHIPPER_TIP',
    preferredOnly: 'PREFERRED_CARRIER_FOR_SHIPPER_TIP2',
    excluded: 'CARRIER_EXCLUDED_FROM_OFFER_TIP',
};
const emptyCarrierPrefs = [
    { type: 'shorthaul', carriers: [], excluded_carriers: [] },
    { type: 'drayage', carriers: [], excluded_carriers: [] },
];
class CarrierPreferences extends Component {
    constructor(props) {
        super(props);
        this.showEditModal = () => {
            this.setState({ showEditModal: true });
        };
        this.hideEditModal = () => {
            this.setState({ showEditModal: false });
        };
        this.handleDragOver = (e) => {
            e.preventDefault();
            this.setState({
                hovering: true,
            });
        };
        this.handleDragLeave = () => this.setState({ hovering: false });
        this.handleCarrierFieldChange = () => {
            this.setState({
                carrier: {
                    name: '',
                    _id: null,
                },
            });
        };
        this.handleCarrierSelect = (item, value) => {
            const { staged_carriers } = this.state;
            if (staged_carriers.find((element) => element._id === value._id)) {
                return;
            }
            staged_carriers.push(value);
            this.setState({ staged_carriers });
        };
        this.removeStagedCarrier = (carrierId) => {
            const { staged_carriers } = this.state;
            let currentlyStaged = [...staged_carriers];
            const index = currentlyStaged.findIndex((c) => c._id === carrierId);
            if (index !== -1) {
                currentlyStaged.splice(index, 1);
                this.setState({ staged_carriers: currentlyStaged });
            }
        };
        this.carrierAlreadyInList = (carrierId) => {
            const { staged_carriers, shorthaul_carriers, drayage_carriers, shorthaul_excluded, drayage_excluded, type, } = this.state;
            const carriers = type === 'shorthaul' ? shorthaul_carriers : drayage_carriers;
            const excluded_carriers = type === 'shorthaul' ? shorthaul_excluded : drayage_excluded;
            if (carriers.find((element) => element._id === carrierId) ||
                excluded_carriers.find((element) => element._id === carrierId)) {
                return true;
            }
            return false;
        };
        this.handleDrop = (e) => {
            const { staged_carriers, shorthaul_carriers, drayage_carriers, shorthaul_excluded, drayage_excluded, type, } = this.state;
            const carriers = type === 'shorthaul' ? shorthaul_carriers : drayage_carriers;
            const carrierIdString = e.dataTransfer.getData('carrier');
            e.stopPropagation();
            const carrierId = JSON.parse(carrierIdString);
            if (this.carrierAlreadyInList(carrierId)) {
                return this.setState({ hovering: false });
            }
            const carrier = staged_carriers.find((element) => element._id === carrierId);
            const newCarrier = {
                sequence: carriers.length + 1,
                _id: carrier._id,
                name: carrier.name,
                carrier: carrier._id,
            };
            carriers.push(newCarrier);
            if (type === 'shorthaul') {
                this.setState({ shorthaul_carriers: carriers, hovering: false });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_carriers: carriers, hovering: false });
            }
        };
        this.handleExcludedDrop = (e) => {
            const { staged_carriers, shorthaul_excluded, drayage_excluded, type } = this.state;
            const carriers = type === 'shorthaul' ? shorthaul_excluded : drayage_excluded;
            const carrierString = e.dataTransfer.getData('carrier');
            e.stopPropagation();
            const carrierId = JSON.parse(carrierString);
            if (this.carrierAlreadyInList(carrierId)) {
                return this.setState({ hovering: false });
            }
            const carrier = staged_carriers.find((element) => element._id === carrierId);
            const newCarrier = {
                _id: carrier._id,
                name: carrier.name,
            };
            carriers.push(newCarrier);
            if (type === 'shorthaul') {
                this.setState({ shorthaul_excluded: carriers, hovering: false });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_excluded: carriers, hovering: false });
            }
        };
        this.removeExcludedCarrier = (index) => {
            const { drayage_excluded, shorthaul_excluded, type } = this.state;
            const carriers = type === 'shorthaul' ? shorthaul_excluded : drayage_excluded;
            let currentlyExcluded = [...carriers];
            if (index !== -1) {
                currentlyExcluded.splice(index, 1);
                if (type === 'shorthaul') {
                    this.setState({
                        shorthaul_excluded: currentlyExcluded,
                        hovering: false,
                    });
                }
                else if (type === 'drayage') {
                    this.setState({ drayage_excluded: currentlyExcluded, hovering: false });
                }
            }
        };
        this.clearExcludedCarriers = () => {
            const { type } = this.state;
            if (type === 'shorthaul') {
                this.setState({ shorthaul_excluded: [] });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_excluded: [] });
            }
        };
        this.handleDragStart = (carrier) => (e) => {
            e.dataTransfer.setData('carrier', JSON.stringify(carrier._id));
            this.setState((prevState) => {
                return {
                    dragging: Object.assign(Object.assign({}, prevState.dragging), { [carrier._id]: true }),
                };
            });
        };
        this.handleDragEnd = (carrier) => () => this.setState((prevState) => {
            const dragging = Object.assign({}, prevState.dragging);
            delete dragging[carrier._id];
            return {
                carrier,
            };
        });
        this.onSortEnd = ({ oldIndex, newIndex }) => {
            const { shorthaul_carriers, drayage_carriers, type } = this.state;
            let carriers = type === 'shorthaul' ? shorthaul_carriers : drayage_carriers;
            carriers = arrayMove(carriers, oldIndex, newIndex);
            carriers = carriers.map((carrier, idx) => {
                carrier.sequence = idx + 1;
                return carrier;
            });
            if (type === 'shorthaul') {
                this.setState({ shorthaul_carriers: carriers });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_carriers: carriers });
            }
        };
        this.handleRemovePreferredCarrier = (sequence, index) => {
            const { shorthaul_carriers, drayage_carriers, type } = this.state;
            let carriers = type === 'shorthaul' ? [...shorthaul_carriers] : [...drayage_carriers];
            if (index !== -1) {
                carriers.splice(index, 1);
            }
            const carriersUpdated = carriers.map((carrier, idx) => {
                carrier.sequence = idx + 1;
                return carrier;
            });
            if (type === 'shorthaul') {
                this.setState({ shorthaul_carriers: carriersUpdated });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_carriers: carriersUpdated });
            }
        };
        this.handleCarrierDurationChange = (sequence, value) => {
            const { shorthaul_carriers, drayage_carriers, type } = this.state;
            const carriers = type === 'shorthaul' ? shorthaul_carriers : drayage_carriers;
            const carrierIndex = carriers.findIndex((c) => {
                return c.sequence === sequence;
            });
            const updatedCarriers = [...carriers];
            const carrier = carriers[carrierIndex];
            updatedCarriers[carrierIndex] = Object.assign({}, carrier, {
                duration: value,
            });
            if (type === 'shorthaul') {
                this.setState({ shorthaul_carriers: updatedCarriers });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_carriers: updatedCarriers });
            }
        };
        this.handleSave = async () => {
            const { shorthaul_carriers, drayage_carriers, shorthaul_excluded, drayage_excluded, shorthaul_preferred_only, drayage_preferred_only, } = this.state;
            const shorthaulPayload = shorthaul_carriers.map((c) => {
                let carrier = {
                    carrier: c.carrier,
                    sequence: c.sequence,
                };
                if (c.duration && parseInt(c.duration, 10)) {
                    carrier.duration = c.duration * 60000; // convert to ms
                }
                return carrier;
            });
            const drayagePayload = drayage_carriers.map((c) => {
                let carrier = {
                    carrier: c.carrier,
                    sequence: c.sequence,
                };
                if (c.duration && parseInt(c.duration, 10)) {
                    carrier.duration = c.duration;
                }
                return carrier;
            });
            const updates = [
                {
                    shipper: this.props.shipper._id,
                    type: 'shorthaul',
                    carriers: shorthaulPayload,
                    excluded_carriers: shorthaul_excluded.map((c) => c._id),
                    preferred_only: shorthaul_preferred_only,
                },
                {
                    shipper: this.props.shipper._id,
                    type: 'drayage',
                    carriers: drayagePayload,
                    excluded_carriers: drayage_excluded.map((c) => c._id),
                    preferred_only: drayage_preferred_only,
                },
            ];
            try {
                const res = await updateCarrierPreferences(this.props.shipper._id, updates);
                const carrierPreferences = res.map((r) => r.items);
                this.setState({ carrierPreferences }, this.handleClose);
            }
            catch (e) {
                console.log('Error: Unable to update carrier preferences');
            }
        };
        this.handleClose = () => {
            this.setState({ showEditModal: false });
        };
        this.handlePreferredOnlyCheckbox = (checked) => {
            const { type } = this.state;
            if (type === 'shorthaul') {
                this.setState({ shorthaul_preferred_only: checked });
            }
            else if (type === 'drayage') {
                this.setState({ drayage_preferred_only: checked });
            }
        };
        this.renderTooltip = (localizationSlug) => {
            const { t } = this.props;
            return React.createElement(Tooltip, { id: localizationSlug }, t(localizationSlug));
        };
        this.state = {
            showEditModal: false,
            staged_carriers: [],
            shorthaul_carriers: [],
            drayage_carriers: [],
            shorthaul_excluded: [],
            drayage_excluded: [],
            carrier: {}, // carrier from select field
            type: 'shorthaul',
            hovering: false,
            dragging: {},
            carrierPreferences: emptyCarrierPrefs, // from API call
            shorthaul_preferred_only: false,
            drayage_preferred_only: false,
        };
    }
    async componentDidMount() {
        try {
            const res = await getCarrierPreferences(this.props.shipper._id);
            if (!res.length) {
                return null;
            }
            res.forEach((carrierPref) => {
                const carriersFormatted = carrierPref.carriers.map((c) => {
                    return {
                        sequence: c.sequence,
                        duration: c.duration ? c.duration / 60000 : null,
                        name: c.carrier.name,
                        _id: c.carrier._id,
                        carrier: c.carrier._id,
                    };
                });
                if (carrierPref.type === 'shorthaul') {
                    this.setState({
                        carrierPreferences: res,
                        shorthaul_carriers: carriersFormatted,
                        shorthaul_preferred_only: carrierPref.preferred_only,
                        shorthaul_excluded: carrierPref.excluded_carriers,
                    });
                }
                else if (carrierPref.type === 'drayage') {
                    this.setState({
                        carrierPreferences: res,
                        drayage_carriers: carriersFormatted,
                        drayage_preferred_only: carrierPref.preferred_only,
                        drayage_excluded: carrierPref.excluded_carriers,
                    });
                }
            });
        }
        catch (e) {
            console.error('Error getting carrier preferences', e);
        }
    }
    /* User is able to search for carriers and add them to Staging List */
    renderCarrierSearch() {
        const carrierName = this.state.carrier ? this.state.carrier.name : '';
        const { t } = this.props;
        return (React.createElement("div", { className: "w-full" },
            React.createElement("fieldset", { className: "md:mr-2" },
                React.createElement("label", { className: "block mb-2 form-label uppercase pl-2 text-grey-dark" }, t('CARRIER_SEARCH')),
                React.createElement("div", { id: "order-carrier-search-container", className: "mb-4 customer-search w-48" },
                    React.createElement(CustomerSearch, { id: "order-carrier-search", clearOnSelect: false, onChange: this.handleCarrierFieldChange, onSelect: this.handleCarrierSelect, placeholder: t('SEARCH_FOR_CARRIER'), value: carrierName, type: "carriers", allowUnauthorizedCarriers: true })))));
    }
    /* Staging Area - Carriers are draggable objects */
    renderStagedCarriers() {
        const { staged_carriers } = this.state || [];
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex flex-wrap mb-4" }, staged_carriers.map((carrier, index) => {
                const dragging = this.state.dragging.hasOwnProperty(carrier._id);
                const className = classnames({
                    'cursor-pointer': true,
                    'rounded-full': true,
                    shadow: true,
                    'max-w-xs': true,
                    'bg-white': !dragging,
                    'px-4': true,
                    'border-green-light': !dragging,
                    'border border-solid': true,
                    'border-green-darker': dragging,
                    'bg-green-lightest': dragging,
                    flex: true,
                    'justify-center': true,
                    'items-center': true,
                    'mr-2': true,
                    'mb-2': true,
                });
                return (React.createElement("div", { draggable: true, key: index, className: className, onDragStart: this.handleDragStart(carrier), onDragEnd: this.handleDragEnd(carrier) },
                    carrier.name,
                    React.createElement(DeleteButton, { className: "ml-2", size: "small", onClick: () => this.removeStagedCarrier(carrier._id) })));
            }))));
    }
    renderCarrierList() {
        const { hovering, shorthaul_carriers, drayage_carriers, type } = this.state;
        const { t } = this.props;
        const carriers = type === 'shorthaul' ? shorthaul_carriers : drayage_carriers;
        const className = classnames({
            'bg-white': true,
            rounded: true,
            relative: true,
            'border-transparent': !hovering,
            'border-green': hovering,
            'border-solid': hovering,
            border: true,
            'w-full': true,
            'overflow-y-auto': true,
            'max-h-72': true,
        });
        if (!carriers || !carriers.length) {
            return (React.createElement("div", { className: "box-border md:box-content p-4 bg-grey-lighter rounded w-full h-14 border-dotted", onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave, onDrop: this.handleDrop },
                React.createElement("span", { className: "italic text-grey" }, t('DRAG_PREFERRED_CARRIERS'))));
        }
        return (React.createElement("div", { className: "w-full" },
            React.createElement("div", { className: className, onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave, onDrop: this.handleDrop },
                React.createElement("table", { className: "default-table small-table-row" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, t('SEQ')),
                            React.createElement("th", null, t('NAME')),
                            React.createElement("th", null, t('DURATION_MIN')),
                            React.createElement("th", null, titleize(t('ACTION', { count: 2 }))))),
                    React.createElement(SortableContainer, { onSortEnd: this.onSortEnd, pressDelay: 100, pressThreshold: 10 }, carriers.map((carrier, index) => (React.createElement(SortableItem, { key: carrier.sequence, index: index },
                        React.createElement("td", null,
                            React.createElement("div", { className: "text-xs" }, carrier.sequence)),
                        React.createElement("td", null,
                            React.createElement("div", { className: "text-xs break-all", title: carrier.name }, carrier.name)),
                        React.createElement("td", null,
                            React.createElement("div", { className: "text-xs", title: carrier.duration },
                                React.createElement(CargomaticInput, { className: "w-16", hideLabel: true, type: "number", min: 0, onChange: (value) => this.handleCarrierDurationChange(carrier.sequence, value), value: carrier.duration || '' }))),
                        React.createElement("td", null,
                            React.createElement("div", null,
                                React.createElement(DeleteButton, { onClick: () => this.handleRemovePreferredCarrier(carrier.sequence, index) })))))))))));
    }
    renderExcludedCarriers() {
        const { shorthaul_excluded, drayage_excluded, type, hovering } = this.state;
        const { t } = this.props;
        const carriers = type === 'shorthaul' ? shorthaul_excluded : drayage_excluded;
        const className = classnames({
            'bg-white': true,
            'p-4': true,
            rounded: true,
            relative: true,
            'border-transparent': !hovering,
            'border-green': hovering,
            'border-solid': hovering,
            border: true,
            'border-dotted': true,
        });
        const carrierList = carriers.map((s, index) => {
            return (React.createElement("div", { key: s._id, className: "py-1" },
                React.createElement("span", { className: "rounded bg-green text-white font-bold text-sm py-1 px-2 mr-2" },
                    s.name,
                    React.createElement("a", { href: "#", className: "pl-2 text-white", "aria-label": t('CLOSE'), onClick: () => this.removeExcludedCarrier(index) },
                        React.createElement("i", { className: "fa fa-close" })))));
        });
        return (React.createElement("div", { className: "w-full p-2 mt-4" },
            React.createElement("div", { className: "flex flex-row justify-between" },
                React.createElement("div", { className: "flex items-center space-x-1" },
                    React.createElement("label", { className: "block mt-2 form-label ml-2" }, t('EXCLUDED_CARRIERS')),
                    React.createElement(OverlayTrigger, { placement: "top", overlay: this.renderTooltip(TOOLTIPS.excluded) },
                        React.createElement("div", { className: "mt-2" },
                            React.createElement(InfoIcon, { size: "medium" })))),
                React.createElement("button", { className: "text-xs rounded-full py-3 px-6 border-red-500 flex inline-flex", onClick: () => this.clearExcludedCarriers() }, titleize(t('CLEAR')))),
            React.createElement("ul", { className: "flex flex-row overflow-x-auto ml-2 mb-2" }, carrierList),
            React.createElement("div", { className: "box-border md:box-content p-4 bg-grey-lighter rounded", onDragOver: this.handleDragOver, onDragLeave: this.handleDragLeave, onDrop: this.handleExcludedDrop },
                React.createElement("span", { className: "italic text-grey" }, t('DRAG_EXCLUDED_CARRIERS')))));
    }
    /* List Displayed on Shipment Details */
    renderCarrierShortlist() {
        const { t } = this.props;
        const { carrierPreferences } = this.state;
        if (!carrierPreferences) {
            return null;
        }
        const drayageCarriers = _.first(carrierPreferences.filter((c) => c.type === 'drayage'));
        const shorthaulCarriers = _.first(carrierPreferences.filter((c) => c.type === 'shorthaul'));
        if (!drayageCarriers || !shorthaulCarriers) {
            return null;
        }
        return (React.createElement("div", { className: "flex flex-col" },
            React.createElement("div", { className: "flex flex-col space-around " },
                React.createElement("h4", { className: "mb-1 text-grey-darker mt-0" }, titleize(t('SHORTHAUL'))),
                React.createElement("p", { className: "font-medium" },
                    shorthaulCarriers.carriers.length,
                    " ",
                    t('PREFERRED_CARRIERS')),
                React.createElement("p", { className: "font-medium" },
                    shorthaulCarriers.excluded_carriers.length,
                    ' ',
                    t('EXCLUDED_CARRIERS'))),
            React.createElement("div", { className: "flex flex-col space-around " },
                React.createElement("h4", { className: "mb-1 text-grey-darker" }, titleize(t('DRAYAGE'))),
                React.createElement("p", { className: "font-medium" },
                    drayageCarriers.carriers.length,
                    " ",
                    t('PREFERRED_CARRIERS')),
                React.createElement("p", { className: "font-medium" },
                    drayageCarriers.excluded_carriers.length,
                    " ",
                    t('EXCLUDED_CARRIERS')))));
    }
    renderModalBody() {
        const { t } = this.props;
        const { type, shorthaul_preferred_only, drayage_preferred_only } = this.state;
        const checkboxValue = type === 'shorthaul' ? shorthaul_preferred_only : drayage_preferred_only;
        const hoverStyle = 'text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none text-blue-500 border-b-2 font-medium border-blue-500';
        const buttonStyle = 'text-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none';
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex flex-row w-full" },
                React.createElement("div", { className: "w-1/2" }, this.renderCarrierSearch()),
                React.createElement("div", { className: "w-1/2" },
                    React.createElement("label", { className: "block mb-2 form-label uppercase pl-2 text-grey-dark" }, t('READY_TO_DROP')),
                    this.renderStagedCarriers())),
            React.createElement("div", null,
                React.createElement("p", { className: "text-grey italic" }, t('DRAG_PREFERRED_OR_EXCLUDED_CARRIER_TIP'))),
            React.createElement("hr", null),
            React.createElement("div", { className: "flex flex-row" },
                React.createElement("div", { className: "bg-white" },
                    React.createElement("nav", { className: "flex flex-col sm:flex-row" },
                        React.createElement("button", { className: type === 'shorthaul' ? hoverStyle : buttonStyle, onClick: () => this.setState({ type: 'shorthaul' }) }, titleize(t('SHORTHAUL'))),
                        React.createElement("button", { className: type === 'drayage' ? hoverStyle : buttonStyle, onClick: () => this.setState({ type: 'drayage' }) }, titleize(t('DRAYAGE')))))),
            React.createElement("div", { className: "flex flex-row justify-between" },
                React.createElement("div", null,
                    React.createElement("div", { className: "flex items-center space-x-1" },
                        React.createElement("label", { className: "block mb-2 mt-4 ml-2 form-label" }, t('PREFERRED_CARRIER_LIST')),
                        React.createElement(OverlayTrigger, { placement: "top", overlay: this.renderTooltip(TOOLTIPS.preferredCarrier) },
                            React.createElement("div", { className: "mt-2" },
                                React.createElement(InfoIcon, { size: "medium" }))))),
                React.createElement("div", null,
                    React.createElement("div", { className: "flex items-center space-x-1" },
                        React.createElement(CargomaticInput, { type: "checkbox", label: t('PREFERRED_ONLY'), className: "block mb-2 mt-4", value: checkboxValue, onChange: (checked) => {
                                this.handlePreferredOnlyCheckbox(checked);
                            } }),
                        React.createElement(OverlayTrigger, { placement: "top", overlay: this.renderTooltip(TOOLTIPS.preferredOnly) },
                            React.createElement("div", { className: "mt-2" },
                                React.createElement(InfoIcon, { size: "medium" })))))),
            React.createElement("div", null,
                React.createElement("p", { className: "text-grey italic ml-2" }, t('DRAG_CARRIER_CHANGE_SEQ_TIP'))),
            React.createElement("div", { className: "flex flex-row" }, this.renderCarrierList()),
            React.createElement("hr", { style: { margin: '0px' } }),
            React.createElement("div", { className: "flex flex-row" }, this.renderExcludedCarriers()),
            React.createElement("div", { className: "flex flex-row-reverse justify-between mt-4" },
                React.createElement("div", { className: "" },
                    React.createElement("button", { className: "button bg-grey text-white mr-2", onClick: () => this.handleClose() }, t('CANCEL')),
                    React.createElement("button", { className: "button bg-green hover:bg-green-dark text-white mr-2", onClick: () => this.handleSave() }, titleize(t('SAVE')))))));
    }
    render() {
        const { showEditModal } = this.state;
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(CargomaticCard, { header: () => (React.createElement("header", { className: "cursor-pointer group", onClick: this.showEditModal },
                        React.createElement("div", { className: "flex items-center justify-between" },
                            React.createElement("h3", { className: "my-0" }, t('CARRIER_PREFERENCES')),
                            React.createElement(EditButton, null)))) }, this.renderCarrierShortlist())),
            React.createElement("div", null, showEditModal && (React.createElement(CargomaticModal, { show: true, onHide: this.hideEditModal, title: t('EDIT_PREFERRED_CARRIERS'), backdrop: "static", body: this.renderModalBody(), footer: null, location: "middle" })))));
    }
}
export default withTranslation()(CarrierPreferences);
